module.exports = __webpack_public_path__ + "static/building-3154201ccb34719cef6543d86c13205e.jpg";